import { Select } from '@mantine/core';
import { GridApi } from 'ag-grid-community';
import useFilterValue, { FilterChangeCallback } from 'components/tables/filters/hooks/use-filter-value';

/** Filters sections by built-in or custom type through the shared table filter model. */
export default function EvidenceFieldSectionTypeSelectFilter({
  api,
  onChange,
}: {
  api: GridApi;
  onChange?: FilterChangeCallback;
}) {
  const [value, setValue] = useFilterValue({ api, filterKey: 'builtinKey', onChange, type: 'equals' });
  return (
    <Select
      clearable
      w="100%"
      size="sm"
      placeholder="Všetky typy"
      value={value}
      onChange={setValue}
      data={[
        { value: 'builtin', label: 'Predvolená sekcia' },
        { value: 'custom', label: 'Vlastná sekcia' },
      ]}
    />
  );
}
